module.exports = __webpack_public_path__ + "static/media/security-user.e025f714.svg";